import React from "react";
import Lottie from "lottie-react";
import commingSoon from "../../assets/lotties/coming soon.json";
import "./commingSoon.css";

export const ComingSoon = () => {
  return (
    <div className="comingSoon-container">
      <Lottie 
        animationData={commingSoon} 
        loop={true} 
        className="comingSoon-lottie-animation" 
      />
    </div>
  );
};

export default ComingSoon;
